import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Yoga = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        AOS.init({ duration: 1000 });
    }, []);
    return (
        <div className="container mx-auto px-6 py-12">
            {/* Heading */}
            <h1 className="text-3xl font-bold text-center mb-6">YOGA</h1>


            <div className="w-full" data-aos="fade-up">
                <p className="text-lg  text-gray-700 leading-relaxed">
                    Yoga is an integral part of our curriculum, promoting physical fitness, mental well-being, and inner peace. Through guided sessions, students learn various asanas, breathing techniques, and mindfulness practices. Regular yoga practice enhances concentration, reduces stress, and fosters a healthy lifestyle, helping students achieve a balanced and focused mind.
                </p>

                <ul className="list-disc list-inside text-gray-700 mt-4">
                    <li>Improves physical fitness and flexibility</li>
                    <li>Enhances concentration and mental clarity</li>
                    <li>Reduces stress and promotes relaxation</li>
                    <li>Teaches breathing techniques and mindfulness</li>
                    <li>Encourages a healthy and balanced lifestyle</li>
                </ul>
            </div>



            {/* Image Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-8" data-aos="fade-up">
                <img src="https://img.freepik.com/premium-vector/little-girl-doing-gymnastic-fitness-exercises-practicing-yoga-pose-green-mat-indoor-home_535862-112.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 1" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/premium-vector/little-girl-doing-gymnastic-fitness-exercises-practicing-yoga-pose-green-mat-indoor-home_535862-112.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 2" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/premium-vector/little-girl-doing-gymnastic-fitness-exercises-practicing-yoga-pose-green-mat-indoor-home_535862-112.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 3" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/premium-vector/little-girl-doing-gymnastic-fitness-exercises-practicing-yoga-pose-green-mat-indoor-home_535862-112.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 4" className="w-full h-48 object-cover rounded-lg shadow-md" />
            </div>

            {/* Image Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-8" data-aos="fade-up">
                <img src="https://img.freepik.com/premium-vector/group-people-practicing-yoga_1308-118167.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 1" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/premium-vector/group-people-practicing-yoga_1308-118167.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 2" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/premium-vector/group-people-practicing-yoga_1308-118167.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 3" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/premium-vector/group-people-practicing-yoga_1308-118167.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 4" className="w-full h-48 object-cover rounded-lg shadow-md" />
            </div>
        </div>
    );
}

export default Yoga;





